/* istanbul ignore file */

import { Directive, Signal, TemplateRef, computed, input } from '@angular/core';

@Directive({
  selector: 'ng-template[override]',
  standalone: true,
})
export class TemplateOverrideDirective {
  name = input.required<string>({ alias: 'override' });
  constructor(public templateRef: TemplateRef<any>) {}
}

export function findTemplateOverride(
  overrides: Signal<readonly TemplateOverrideDirective[]>,
  name: string
): Signal<TemplateRef<any> | undefined> {
  return computed(() => {
    return overrides().find((o) => o.name() === name)?.templateRef;
  });
}
